import {ReactNode} from 'react';
import PropTypes from 'prop-types';
import {Navigate} from "react-router-dom";
import {PlatformLoader} from "@flexinet/ui-components";
import {useAuth} from "../hooks/useAuth.ts";


export const RequireAuth = ({children}: { children: ReactNode }) => {
    const {user, status} = useAuth();
    // `user` is undefined until Amplify answers, on every hard load. Redirecting
    // then bounces a signed-in deep link off the page it asked for. FNP-1728.
    if (status === 'resolving') {
        return <PlatformLoader message="Loading...Please wait!"/>;
    }
    if (!user) {
        return <Navigate to="/"/>;
    }
    return children;
};

RequireAuth.propTypes = {
    children: PropTypes.node,
};
